// extracted by mini-css-extract-plugin
export default {"videoBlock":"VideoBlock_videoBlock__sebRn","blockContainer":"VideoBlock_blockContainer__LNm46"};